/** localStorage helpers that never throw (private mode, disabled storage). */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? { ...fallback, ...(JSON.parse(raw) as object) } : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable: settings last for this page only.
  }
}

export const STORAGE_KEYS = {
  filters: 'oaa.kpi.filters',
  prefs: 'oaa.kpi.prefs',
  nav: 'oaa.kpi.nav.open',
  charts: 'oaa.kpi.charts.hidden',
  views: (entity: string) => `oaa.kpi.views.${entity}`,
} as const;
